import { render, staticRenderFns } from "./Pengajuan.vue?vue&type=template&id=3117a908&scoped=true"
import script from "./Pengajuan.vue?vue&type=script&lang=js"
export * from "./Pengajuan.vue?vue&type=script&lang=js"
import style0 from "./Pengajuan.vue?vue&type=style&index=0&id=3117a908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117a908",
  null
  
)

export default component.exports